import type { RuleKey } from "../sim";

/** Player-facing names and one-line explanations of the optional match rules. */
export const RULE_TEXT: Record<RuleKey, { label: string; description: string }> = {
	wrapPhysics: {
		label: "Seamless space",
		description: "Gravity and collisions reach across the edge of the map.",
	},
	fuel: {
		label: "Fuel",
		description: "Thrusting burns fuel; it slowly refills while you coast.",
	},
	fuelStations: {
		label: "Fueling stations",
		description:
			"The map's fueling stations refill your tank while you stay inside their dotted circle (needs Fuel).",
	},
	laserOverheat: {
		label: "Laser overheat",
		description: "Every shot heats the laser; overheat it and it locks until it has cooled down.",
	},
	powerUps: {
		label: "Power-ups",
		description: "Pods with power-ups appear around the map; fly through one to use it.",
	},
	damage: {
		label: "Hull damage",
		description: "Ships survive a few hits instead of exploding at the first one.",
	},
	laserBounce: {
		label: "Laser bounce",
		description: "Lasers ricochet off planets.",
	},
	asteroidSplitting: {
		label: "Asteroid splitting",
		description:
			"A laser splits an asteroid into two smaller ones (missiles still destroy them whole).",
	},
	safeAsteroidSpawns: {
		label: "Safe asteroid spawns",
		description:
			"New asteroids appear away from ships and spawn points instead of at the spawn points.",
	},
};
